import config from "@/config"
import dayjs from 'dayjs'
// import store from '../store'
import militaryAndLanguage from "@/helpers/militaryAndLanguage"

class Supervisor {
  constructor (propsData, status, finishedTable) {
    this.propsData = propsData
      let mutableData = this.propsData.map(el => {
        let svgName = 'success-mk'
        if (el.status === 'Отменен') svgName = 'cancel-mk'
        if (el.status === 'В работе') svgName = 'time-mk'
        let row = {
          amoId: `${config.AMO_LINK}${el.amocrm_id}`,
          amoIdOnlyId: el.amocrm_id,
          date: {
            start: dayjs(el.mk_starts_at).format('DD.MM.YYYY'),
            hour: militaryAndLanguage() ? dayjs(el.mk_starts_at).format('HH:mm') : dayjs(el.mk_starts_at).format('hh:mm a'),
          },
          mimk: el.mimk_name || ('__').toUpperCase(),
          mimkId: el.mimk,
          mcId: el.id,
          hour_before_confirmed: el.hour_before_confirmed,
          status_translated: el.status_translated,
          kid_name: el.kid_name,
          kid_age: el.kid_age,
          zoom_start_url: el.zoom_start_url,
          zoom_join_url: el.zoom_join_url,
          zoom_link_in_wa_sent: el.zoom_link_in_wa_sent,
          zoom_link_in_mail_sent: el.zoom_link_in_mail_sent,
          zoom_session_starts_at: el.zoom_session_starts_at,
          zoom_session_ends_at: el.zoom_session_ends_at,
          status: {
            status: el.status,
            svgName
          }

        }
        console.log(row);
      if (status) row.status = {
        text: el.status,
        svgName,
      }
      if (!finishedTable) {
        row.buttons = {
        haveMimk: el.mimk_name
      }
      } else row.comment = el.additional_info || '-'
      return row
    })
    return mutableData
  }
}

class mimkTable {
  constructor (propsData) {
    this.propsData = propsData
    let mutableData = this.propsData.map(el => {
      let svgName = 'success-mk'
      if (el.status === 'Отменен') svgName = 'cancel-mk'
      if (el.status === 'В работе') svgName = 'time-mk'
      const mcObject =  {
        id: el.id,
        student: {
          name: el.kid_name,
          info: el.additional_info
        },
        date: {
          start: dayjs(el.mk_starts_at).format('DD.MM.YYYY'),
          hour: militaryAndLanguage() ? dayjs(el.mk_starts_at).format('HH:mm') : dayjs(el.mk_starts_at).format('hh:mm a'),
        },
        extraInformation: {
          parentName: el.parent_name,
          parentNumber: el.parent_whatsapp,
          segment: el.segment,
          tcReport: el.report_id,
          paymentReport: el.report_after_payment,
          reportId: el.report_id,
          tcNumber: el.tc_number,
        },
        mimkId: el.mimk,
        status_translated: el.status_translated,
        status: el.status,
        zoom_start_url: el.zoom_start_url,
        zoom_join_url: el.zoom_join_url,
        zoom_session_starts_at: el.zoom_session_starts_at,
        zoom_session_ends_at: el.zoom_session_ends_at,
        svgName
      }
      if (el.backoffice_id) mcObject.extraInformation.backofficeLink = `${config.BACKOFFICE_LINK}${el.backoffice_id}`
      if (el.amocrm_id) mcObject.extraInformation.amoLink = `${config.AMO_LINK}${el.amocrm_id}`
      return mcObject
    })
    return mutableData
  }
}

export { Supervisor, mimkTable }
